import PauseIcon from "@medoma/components/icons/PauseIcon";
import styles from "./PausedIndicator.module.scss";
import { useLingui } from "@lingui/react/macro";

const PausedIndicator = () => {
  const { t } = useLingui();

  return (
    <div className={styles.pausedIndicator} title={t`Pausad`}>
      <PauseIcon />
    </div>
  );
};

export default PausedIndicator;
